import { __assign } from "tslib";
// DS: I32B
import React from 'react';
import IconWrap from '../IconWrap';
var instances = 0;
var CloseBig = function (props) {
    var instanceId = instances++;
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "0", height: "0", viewBox: "0 0 24 24" },
            React.createElement("defs", null,
                React.createElement("path", { id: "i32-b-" + instanceId, d: "M13.765 12L22 20.235 20.235 22 12 13.765 3.765 22 2 20.235 10.235 12 2 3.765 3.765 2 12 10.235 20.235 2 22 3.765 13.765 12z" })),
            React.createElement("g", { fillRule: "evenodd" },
                React.createElement("use", { fill: "currentColor", xlinkHref: "#i32-b-" + instanceId })))));
};
CloseBig.displayName = 'CloseBig';
export default CloseBig;
//# sourceMappingURL=CloseBig.js.map